import React from "react";
import { connect } from "react-redux";
import Switch from '@material-ui/core/Switch';
import Header from '../Header/Header';
import DocMenu from '../DocMenu';
import NumDoss from '../NumDoss';
import ReminderDetail from './Reminder/ReminderDetail';
import GenPdf from '../GenPdf';
import { getContact, genReminderPDF, getReminderPDF, genReminderTablePDF, getReminderTablePDF, getEch } from './Utils';
import { fetchContrat } from "../../redux/actions/contratActions";
import { fetchAllReminder } from "../../redux/actions/reminderActions";
import { changeTitleName, changePdfFileName } from "../../redux/actions/emailAction";
import "../../Styles/Factures/Reminder.scss";

class Reminder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataFacture: { date_ech: new Date() },
      maitreOuvrage: {},
      first_reminder: true,
      openFile: false,
      file: null,
      disableButton: false,
      clientResponse: false,
      comptableSexe: "male",
      comptableName: "",
      avenantEcheance: {},
    }
  }

  componentDidMount() {
    this.props.dispatch(changePdfFileName(""))
    const { dossierValue, echeances } = this.props;
    if (dossierValue && echeances) {
      const avenantEcheance = getEch(echeances, dossierValue)
      this.setState({ avenantEcheance });
    }
    this.props.dispatch(fetchAllReminder())
  }

  componentDidUpdate(prevProps) {
    const { factures, dossierValue, factureIndex, echeances } = this.props;
    if (factures.length > 0 && (dossierValue !== prevProps.dossierValue || factures !== prevProps.factures || factureIndex !== prevProps.factureIndex)) {
      this.props.dispatch(fetchContrat(dossierValue))
      this.loadData()
    }

    if (dossierValue !== prevProps.dossierValue || echeances !== prevProps.echeances) {
      this.props.dispatch(changePdfFileName(""))
      const avenantEcheance = getEch(echeances, dossierValue)
      this.setState({ avenantEcheance, file: null });
    }
  }

  loadData() {
    this.props.dispatch(changePdfFileName(""));
    const { factures, dossierValue, factureIndex, dossiers, contact } = this.props;

    const maitreOuvrage = getContact(dossiers, contact, dossierValue);
    const filteredFactures = factures.filter(f => f.ndossier === dossierValue);
    const dataFacture =
      factureIndex > 0 && factureIndex <= filteredFactures.length
        ? { ...filteredFactures[factureIndex - 1] }
        : { date_ech: new Date() };

    if (dataFacture.dossier !== undefined && dataFacture.dossier !== null) {
      if (typeof dataFacture.dossier === "string") {
        dataFacture.dossier = JSON.parse(dataFacture.dossier);
      }
      if (Object.keys(dataFacture.dossier).length > 4) {
        dataFacture.date_reminder = new Date().toLocaleDateString('en-CA');
        dataFacture.total_tva = parseFloat((dataFacture.total_ht * (dataFacture.tva / 100)).toFixed(2));
        dataFacture.total_ttc = parseFloat((dataFacture.total_ht * (1 + dataFacture.tva / 100)).toFixed(2));
      }
    }

    this.setState({ dataFacture, maitreOuvrage, file: null });
  }

  handleChangeSwitch() {
    this.setState({ first_reminder: !this.state.first_reminder, clientResponse: false });
  }

  handleDateReminderChange(date) {
    let dataFacture = this.state.dataFacture
    dataFacture.date_reminder = date
    this.setState({ dataFacture, comptableSexe: "male", comptableName: "" });
  }

  handleChangeClientResponse(response) {
    this.setState({ clientResponse: response })
  }

  handleChangeCompatbleInfos(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  getRefFacture(inputString) {
    if (inputString.includes('RX')) {
      return inputString.match(/C\d+/)[0];
    } else if (inputString.includes('CX')) {
      return inputString.match(/R\d+/)[0];
    }
  }

  getSignatureDate(numdossier) {
    const { factures } = this.props
    const firstFacture = factures.find(fac => fac.ndossier === numdossier && fac.numclient.includes('C1'))
    return new Date(firstFacture.date_ech).toLocaleDateString('en-CA')
  }

  getDevisCon() {
    var arr = [];
    for (let i = 0; i < this.props.deviscon.length; i++) {
      if (
        this.props.deviscon[i].ndossier == this.props.dossierValue
      ) {
        arr.push(this.props.deviscon[i]);
      }
    }
    var max = Math.max.apply(
      Math,
      arr.map((item) => item.iddeviscon)
    );
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].iddeviscon == max) {
        return arr[i];
      }
    }
    return "";
  }

  getFirstReminder(numclient) {
    const { reminders } = this.props
    const firstDateReminder = reminders.find(r => r.numclient === numclient && r.first_reminder === 1)
    return firstDateReminder !== undefined ? new Date(firstDateReminder.date_reminder).toLocaleDateString('en-CA') : ""
  }

  formatDate(inputDate) {
    if (inputDate === null || inputDate === "") {
      return "";
    }
    const parts = inputDate.split('-');
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return formattedDate;
  }

  getAllReminders() {
    const { factures, reminders, dossierValue } = this.props
    const filteredAndCalculatedData = [];
    const clientData = {};

    reminders.forEach((item) => {
      if (item.ndossier === dossierValue) {
        const numclient = item.numclient;

        if (!clientData[numclient]) {
          clientData[numclient] = {
            nfacture: "",
            date_ech: "",
            first_reminder: "",
            second_reminder: "",
            date_first_reminder: "",
            date_second_reminder: "",
            validation: factures.filter((element) => element.numclient === numclient)[0].payment_date,
          };
        }

        clientData[numclient].nfacture = `${item.nfacture} ${this.getRefFacture(item.numclient)}`;

        if (!clientData[numclient].date_ech) {
          clientData[numclient].date_ech = new Date(item.date_ech).toLocaleDateString('en-CA');
        }

        if (item.first_reminder === 1) {
          const first_reminder = new Date(clientData[numclient].date_ech);
          first_reminder.setDate(first_reminder.getDate() + 15);
          clientData[numclient].first_reminder = first_reminder.toLocaleDateString('en-CA');
          clientData[numclient].date_first_reminder = new Date(item.date_reminder).toLocaleDateString('en-CA');
        }

        if (item.first_reminder === 0) {
          const second_reminder = new Date(clientData[numclient].date_ech);
          second_reminder.setDate(second_reminder.getDate() + 30);
          clientData[numclient].second_reminder = second_reminder.toLocaleDateString('en-CA');
          clientData[numclient].date_second_reminder = new Date(item.date_reminder).toLocaleDateString('en-CA');
        } else if (!clientData[numclient].second_reminder) {
          clientData[numclient].second_reminder = "";
          clientData[numclient].date_second_reminder = ""
        }
      }
    });

    for (const numclient in clientData) {
      if (clientData.hasOwnProperty(numclient)) {
        const clientInfo = clientData[numclient];
        filteredAndCalculatedData.push({
          numclient: numclient,
          nfacture: clientInfo.nfacture,
          date_ech: this.formatDate(clientInfo.date_ech),
          first_reminder: this.formatDate(clientInfo.first_reminder),
          date_first_reminder: this.formatDate(clientInfo.date_first_reminder),
          second_reminder: clientInfo.second_reminder !== "" ? this.formatDate(clientInfo.second_reminder) : "",
          date_second_reminder: clientInfo.date_second_reminder !== "" ? this.formatDate(clientInfo.date_second_reminder) : "",
          validation: clientInfo.validation !== null ? this.formatDate(clientInfo.validation.slice(0, 10)) : ""
        });
      }
    }
    filteredAndCalculatedData.sort((a, b) => a.numclient.localeCompare(b.numclient))
    return filteredAndCalculatedData
  }

  handleSaveData = async () => {
    const { dataFacture, maitreOuvrage, first_reminder, clientResponse } = this.state
    this.setState({ disableButton: true });
    const date_ech = new Date(dataFacture.date_ech).toLocaleDateString('en-CA')
    const json = {
      ndossier: dataFacture.ndossier,
      numclient: dataFacture.numclient,
      nfacture: dataFacture.nfacture,
      date_ech: date_ech,
      idcontact: maitreOuvrage.idcontact,
      company: dataFacture.dossier.sci_sccv,
      date_reminder: dataFacture.date_reminder,
      amount_ht: dataFacture.total_ht,
      amount_tva: dataFacture.total_tva,
      amount_ttc: dataFacture.total_ttc,
      first_reminder: first_reminder,
      client_response: clientResponse
    };

    const requestOptions = {
      method: "POST",
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(json)
    };

    await fetch("/api/facture/saveReminder", requestOptions)
      .catch((err) => {
        console.log(err);
      });
    await this.props.dispatch(fetchAllReminder())
    await this.setState({ disableButton: false });
  }

  handleGenReminder = async () => {
    this.setState({ disableButton: true });
    const { dataFacture, maitreOuvrage, first_reminder, clientResponse, comptableSexe, comptableName, avenantEcheance } = this.state

    const json = {
      ndossier: dataFacture.ndossier,
      numclient: dataFacture.numclient,
      nfacture: dataFacture.nfacture,
      ref_facture: this.getRefFacture(dataFacture.numclient),
      date_ech: new Date(dataFacture.date_ech).toLocaleDateString('en-CA'),
      date_signature: this.getSignatureDate(dataFacture.ndossier),
      maitre_ouvrage: maitreOuvrage,
      operation: dataFacture.dossier.operation,
      sci_sccv: dataFacture.dossier.sci_sccv,
      operation_adress: dataFacture.dossier.adresse_op + ", " + dataFacture.dossier.cp_op + " - " + dataFacture.dossier.ville_op,
      date_reminder: dataFacture.date_reminder,
      amount_ht: dataFacture.total_ht,
      first_reminder: first_reminder,
      client_response: clientResponse,
      ndossier_: dataFacture.ndossier.toString().split('').join('-'),
      nprop: this.getDevisCon().nprop.toString().length === 1 ? "0" + this.getDevisCon().nprop : this.getDevisCon().nprop,
      date_contrat: avenantEcheance.datepgcp,
      date_first_reminder: this.getFirstReminder(dataFacture.numclient),
      comptable: `${comptableSexe === "male" ? "mon collaborateur" : "ma collaboratrice"} ${comptableName}`
    }

    const requestOptions = {
      method: "POST",
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(json)
    }


    let blob = await genReminderPDF(requestOptions);
    if (blob) {
      this.setState({ file: blob, disableButton: false, openFile: true });
      await this.handleSaveData()
    }
  }

  handleGenReminderTable = async () => {
    this.setState({ disableButton: true });
    const { dataFacture, maitreOuvrage } = this.state

    const data = this.getAllReminders()
    const json = {
      ndossier: dataFacture.ndossier,
      ref_facture: this.getRefFacture(dataFacture.numclient),
      maitre_ouvrage: maitreOuvrage,
      dossier: dataFacture.dossier,
      date_table: new Date(),
      data
    }

    const requestOptions = {
      method: "POST",
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(json)
    }

    let blob = await genReminderTablePDF(requestOptions);
    if (blob) {
      this.setState({ file: blob, disableButton: false, openFile: true });
    }
  }

  handleShowReminderPDF = async () => {
    const { dossierValue } = this.props
    const { dataFacture, first_reminder } = this.state
    this.setState({ file: null, disableButton: true });

    let response = await getReminderPDF(dossierValue, first_reminder, this.getRefFacture(dataFacture.numclient), 'pdf');

    if (response.blob.size > 100) {
      this.setState({ file: response.blob, openFile: true });

      const fileName = response.fileName;
      this.props.dispatch(changePdfFileName(fileName))
    }
    await this.setState({ disableButton: false });
  };

  handleGetPdfFile = async () => {
    const { dossierValue } = this.props
    const { dataFacture, first_reminder } = this.state
    this.setState({ file: null });

    let response = await getReminderPDF(dossierValue, first_reminder, this.getRefFacture(dataFacture.numclient), 'pdf');
    if (response.blob.size > 100) {
      this.setState({ file: response.blob });

      const fileName = response.fileName;
      this.props.dispatch(changePdfFileName(fileName))
    }
  };

  async handleGetWordFile() {
    const { dossierValue } = this.props
    const { dataFacture, first_reminder } = this.state
    this.setState({ file: null });

    let response = await getReminderPDF(dossierValue, first_reminder, this.getRefFacture(dataFacture.numclient), 'word');

    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      this.setState({ file: response.blob });

      const fileName = response.fileName;
      this.props.dispatch(changePdfFileName(fileName))
    }
  }

  handleShowReminderTablePDF = async () => {
    const { dossierValue } = this.props
    this.setState({ file: null, disableButton: true });
    let blob = await getReminderTablePDF(dossierValue);
    if (blob) {
      this.setState({ file: blob.size > 100 ? blob : null, openFile: blob.size > 100 ? true : false });
    }
    await this.setState({ disableButton: false });
  };

  closeDoc = () => {
    this.setState({ openFile: false, file: null });
  }

  handleChangeTitleName() {
    this.props.dispatch(changeTitleName(`${this.state.first_reminder ? "1ère" : "2ème"} Relance`))
  }

  render() {
    const { dataFacture, maitreOuvrage, first_reminder, disableButton, clientResponse, comptableSexe, comptableName, file } = this.state

    return (
      <div className="reminder-container">
        <Header />
        <DocMenu
          file={file}
          getSourceFile={this.handleGetWordFile.bind(this)}
          getPDF={this.handleGetPdfFile.bind(this)}
          handleChangeTitleName={this.handleChangeTitleName.bind(this)}
        />
        <h1 className="title">Relance de Facturation</h1>
        <NumDoss type="reminder" />
        <div className="switch-reminder">
          <span className={first_reminder ? "active1" : "no-active"}>1<sup>ère </sup>Relance</span>
          <Switch color="primary" onChange={this.handleChangeSwitch.bind(this)} />
          <span className={first_reminder ? "no-active" : "active2"}>2<sup>ème </sup>Relance</span>
        </div>
        <ReminderDetail
          first_reminder={first_reminder}
          disableButton={disableButton}
          dataFacture={dataFacture}
          maitreOuvrage={maitreOuvrage}
          clientResponse={clientResponse}
          comptableSexe={comptableSexe}
          comptableName={comptableName}
          handleDateReminderChange={this.handleDateReminderChange.bind(this)}
          handleChangeClientResponse={this.handleChangeClientResponse.bind(this)}
          handleChangeCompatbleInfos={this.handleChangeCompatbleInfos.bind(this)}
          handleSaveData={this.handleSaveData.bind(this)}
          handleGenReminder={this.handleGenReminder.bind(this)}
          handleShowReminderPDF={this.handleShowReminderPDF.bind(this)}
          handleGenReminderTable={this.handleGenReminderTable.bind(this)}
          handleShowReminderTablePDF={this.handleShowReminderTablePDF.bind(this)}
        />
        <GenPdf file={this.state.file} isOpen={this.state.openFile} closeDoc={this.closeDoc} scale={this.state.file !== null ? 1 : 0.5} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  factures: state.facture.allfacture,
  reminders: state.reminder.items,
  deviscon: state.devis.deviscon,
  dossierValue: state.devis.dossierValue,
  factureIndex: state.facture.facindex,
  dossierValue: state.devis.dossierValue,
  dossiers: state.dossier.items,
  contact: state.contact.items,
  echeances: state.echeances.items,
});
export default connect(mapStateToProps)(Reminder);